import andyLogo from '@/images/clients/andy-logo.jpg'
import type { IPartnerSettings } from '.'

export const AndyAuto: IPartnerSettings = {
  partner: 'AndyAuto',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.CommonClient',
    test: 'https://broker.cebia.cz/test',
    prep: 'https://broker.cebia.cz/prep',
    production: 'https://broker.cebia.cz/prod',
  },
  hosts: [
    'srovnavac.andy-auta.cz',
    //, 'localhost:44470'
  ],
  logo: andyLogo
}
